import React from 'react';
import {PageHeader, PageWidget} from "../../components/contentComponents";
import {Button, Divider, Popconfirm, Table} from "antd";
import TableWrapper from "../../components/antdWrappers/TableWrapper";
import {useDispatch, useSelector} from "react-redux";
import withSearchFunction from "../../components/filterColumnSearch/with-search-function";
import {
    getStrategy,
    loadAdminStrategies,
    setVisibleDialog,
    clearEditedStrategyData,
    updateStrategy, deleteStrategy
} from "./adminStrategiesSlice";
import {Icon} from "@iconify/react";
import AdminStrategyDialog from "./AdminStrategyDialog";

const StrategyList = ({columnSearchProps}) => {

    const columns = [
        {
            ...columnSearchProps('стратегия', true),
            title:
                <React.Fragment>
                    <div>Код</div>
                </React.Fragment>
            , dataIndex: 'code'
        }
        ,{
            title:
                <React.Fragment>
                    <div>Наименование</div>
                </React.Fragment>
            , dataIndex: 'name'
        }
        ,{
            title:
                <React.Fragment>
                    <div>Описание</div>
                </React.Fragment>
            , dataIndex: 'description'
            , sorter : false
        }
        ,{
            title:
                <React.Fragment>
                    <div>Доходность</div>
                </React.Fragment>
            , sorter : false
        }
        , {
            title: <Icon fontSize={20} icon='lucide:more-horizontal'/>
            , key: 'action'
            , align: 'center'
            , width: 80
            , render: ( record) => {
                const {code} = record;
                return (
                    <div className='ip-transactions'>
                        <Button type='link'  onClick={() => openDialog(code)}>
                            <Icon fontSize={14} icon='material-symbols:edit-outline'/>
                        </Button>
                        <Divider type="vertical"/>
                        <Popconfirm
                            title={`Вы уверены что хотите удалить стратегию ${code}?`}
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => dispatch(deleteStrategy(code))}
                        >

                            <Button type='link' >
                                <Icon fontSize={14} icon='material-symbols:delete-outline'/>
                            </Button>
                        </Popconfirm>
                    </div>
                );
            },
        }
    ];

    const dispatch = useDispatch();
    const strategies = useSelector(state => state.adminStrategies.strategies);
    const loading = useSelector(state => state.adminStrategies.loading);
    const pagination = useSelector(state => state.adminStrategies.pagination);
    const visibleDialog = useSelector(state => state.adminStrategies.visibleDialog);
    const editedStrategy = useSelector(state => state.adminStrategies.editedStrategy);

    const openDialog = async (code) => {
        if (code) {
            await dispatch(getStrategy(code)).unwrap();
        }
        else {
            dispatch(clearEditedStrategyData());
            console.log(editedStrategy);
        }
        dispatch(setVisibleDialog(true));
    }

    const closeDialog = () => {
        dispatch(setVisibleDialog(false));
    };

    const handleDialogResult = (result, values) => {
        if (result) {
            dispatch(updateStrategy(values));
        }
        closeDialog();
    };


    return(
        <>
            <PageHeader caption='Стратегии' />
            <PageWidget >
                <div>
                    <div>
                        <Button type="link"
                                onClick={()=>{
                                    openDialog()
                                }}
                        >
                            Добавить стратегию
                        </Button>
                    </div>
                    <TableWrapper>
                        <Table
                            columns={columns}
                            rowKey='code'
                            dataSource={strategies}
                            loading={loading}
                            pagination={pagination}
                            size="small"
                            bordered
                            onChange={( pagination, tableFilters, sorter) => {
                                const {field, order} = sorter;
                                const sort = { field, order };
                                dispatch(loadAdminStrategies( null, pagination, tableFilters, null));
                            }}
                        />
                    </TableWrapper>
                </div>
            </PageWidget>
            <AdminStrategyDialog
                visible={visibleDialog}
                data={editedStrategy}
                dialogHandler={handleDialogResult}
            />
        </>
    )
}

const StrategyListPage = withSearchFunction( StrategyList );
export default StrategyListPage;
